import ScheduleAPI, {
  Schedule,
  ScheduleQuery,
  ScheduleQueryResponse,
} from "apis/ScheduleAPI";
import { useCallback, useEffect } from "react";
import {
  useCalendarDispatch,
  useCalendarState,
} from "../context/CalendarContext";
import { updateSchedulesOnCalendar } from "../context/utils";
import { eventFormatter, formatQuery } from "./calendarQueryUtils";

export default function useFullCalendarQuery() {
  const calendar = useCalendarState();
  const dispatch = useCalendarDispatch();
  const { currentViewRange, query, refresh } = calendar;

  const loadSchedules = useCallback(
    async (query: ScheduleQuery, results: Schedule[] = []): Promise<void> => {
      try {
        const response = await ScheduleAPI.query(query);
        if (response && response.data) {
          const scheduleQueryResponse = response.data as ScheduleQueryResponse;
          const totalEntitiesLoaded =
            results.length + scheduleQueryResponse.entities.length;
          if (scheduleQueryResponse.entities)
            results.push(...scheduleQueryResponse.entities);
          if (totalEntitiesLoaded !== scheduleQueryResponse.totalElements) {
            return await loadSchedules(
              { ...query, page: query.page + 1 },
              results
            );
          }

          updateSchedulesOnCalendar(dispatch, results.map(eventFormatter));
        } else {
          console.error("Resposta da API não contém dados esperados.");
        }
      } catch (error) {
        console.error("Erro ao carregar agendamentos:", error);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    if (currentViewRange.start === currentViewRange.end) return;
    const formattedQuery = formatQuery(currentViewRange, query);
    if (currentViewRange) loadSchedules(formattedQuery);
  }, [currentViewRange, query, refresh, loadSchedules]);
}
